export default function isPrimaryLink(entry) {
	// some backwards compatibility for old flights
	return entry.isPrimaryLink
}